import { createReducer } from "@reduxjs/toolkit";
import { CATEGORY_ERROR, CATEGORY_LOADING, CATEGORY_LIST } from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const categoryReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(CATEGORY_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(CATEGORY_ERROR, (state, { payload }) => {
      state.error = payload;
    })
    .addCase(CATEGORY_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default categoryReducer;
